export default __webpack_public_path__ + "images/cross-icon.png";